import { render, staticRenderFns } from "./DeliveryMethodView.vue?vue&type=template&id=115495e9&scoped=true&"
import script from "./DeliveryMethodView.vue?vue&type=script&lang=js&"
export * from "./DeliveryMethodView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115495e9",
  null
  
)

export default component.exports